module.exports = __webpack_public_path__ + "static/media/1-belov.ae5ea611.jpg";